import JassAgent from './agent';

/**
 * type widget
 */
export default class JassWidget extends JassAgent {
  health = 0;
  maxHealth = 0;
}
